export const CURRENCIES = {
  USD: "$", EUR: "€", GBP: "£", CAD: "CA$", AUD: "A$", INR: "₹", JPY: "¥",
};

export function money(value, currency = "USD") {
  const sym = CURRENCIES[currency] || "$";
  if (value == null || isNaN(value)) return `${sym}—`;
  return `${sym}${Number(value).toFixed(2)}`;
}

export function unitCost(value, currency = "USD", digits = 3) {
  const sym = CURRENCIES[currency] || "$";
  if (value == null || isNaN(value)) return "—";
  return `${sym}${Number(value).toFixed(digits)}`;
}
